const DsArticle = window.DsArticle || {
  _initialized: false,

  // 1. SCROLL LOCK
  ScrollLock: {
    scrollTop: 0,
    isLocked: false,
    lock() {
      if(this.isLocked) return;
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollBarWidth}px`;

      this.scrollTop = window.scrollY;
      document.body.classList.add('ds-ui-locked');
      document.body.style.top = `-${this.scrollTop}px`;
      this.isLocked = true;
    },
    unlock() {
      if(!this.isLocked) return;
      document.body.classList.remove('ds-ui-locked');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('padding-right');
      window.scrollTo(0, this.scrollTop);
      this.isLocked = false;
    }
  },

  // 2. SMOOTH SCROLL ENGINE (Optimized 2026-01-30)
  // FIX: Changed from easeInOutQuart to easeOutCubic for snappier response
  // FIX: Reduced duration from 1200-3000ms to 400-800ms for better UX
  SmoothScroll: {
    to(element) {
      if(!element) return;
      const targetPos = element.getBoundingClientRect().top + window.pageYOffset - 120;
      const startPos = window.pageYOffset;
      const distance = targetPos - startPos;
      const absDistance = Math.abs(distance);

      // Faster, more responsive duration (400-800ms instead of 1200-3000ms)
      const duration = Math.min(800, Math.max(400, 300 + (absDistance * 0.15)));

      let startTime = null;
      // easeOutCubic: Fast start, smooth deceleration (like iOS momentum)
      const easeOutCubic = (t, b, c, d) => {
        t /= d;
        t--;
        return c * (t * t * t + 1) + b;
      };

      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeOutCubic(timeElapsed, startPos, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      };
      requestAnimationFrame(animation);
    }
  },

  // 3. AUDIO -> ausgelagert nach assets/ds-audio.js (eine robuste Implementierung,
  //             manual-Audio + gehaertetes TTS-Fallback, keine const-Kollision)

  // 4. UI – Vorschau v2 (iframe-Architektur, 2026-07-11)
  //
  // Die Zielseite laedt als same-origin iframe und ist damit die ECHTE Seite
  // mit eigenem Viewport, eigenem CSS/JS und geteiltem Warenkorb-Cookie.
  // Ersetzt die fetch()+innerHTML-Kopie, die ohne Scripts nicht funktionieren
  // konnte (tote Varianten-Picker, haengende Platzhalter). Die Script-Isolation
  // aus Security-Fix B-JS-01 bleibt gewahrt: es wird nichts mehr in den
  // Artikel-DOM injiziert, die Seite laeuft ausschliesslich in ihrem eigenen
  // Browsing-Kontext. Voraussetzung: frame-ancestors 'self' via Edge-Worker
  // ds-frame-headers (Checkout/Account bleiben DENY und brechen deshalb
  // kontrolliert in das Vollfenster aus).
  UI: {
    modal: null, frame: null, previewBody: null, loader: null,
    fullBtn: null, fallback: null, fallbackBtn: null, wrapperEl: null,
    lastTrigger: null, pendingUrl: null, loadCount: 0, historyArmed: false, historySeq: 0,
    atcBusy: false, toastEl: null, toastTimer: null,

    init() {
      this.modal = document.getElementById('DsPreviewModal');
      this.frame = document.getElementById('DsPreviewFrame');
      this.previewBody = document.getElementById('DsPreviewContentArea');
      this.loader = document.getElementById('DsLoader');
      this.fullBtn = document.getElementById('DsPreviewFullBtn');
      this.fallback = document.getElementById('DsPreviewFallback');
      this.fallbackBtn = document.getElementById('DsPreviewFallbackBtn');
      if(!this.modal || !this.frame) return;
      this.wrapperEl = this.modal.querySelector('.ds-preview-wrapper-anim');
      this.initSwipe();

      // Klick-Delegation: interne Links im Artikel + Empfehlungs-Karten
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.ds-trigger-preview, .ds-rte a');
        if(!trigger) return;
        // Browser-Standard respektieren: neue Tabs, Downloads, Modifier-Klicks
        if(trigger.target === '_blank' || trigger.hasAttribute('download')) return;
        if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
        const href = trigger.dataset.url || trigger.getAttribute('href');
        let isInternal = false;
        if(href && !href.startsWith('#') && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
          if(href.startsWith('/')) isInternal = true;
          else { try { isInternal = new URL(href, location.origin).hostname === location.hostname; } catch(err){} }
        }
        if(isInternal) {
          e.preventDefault(); e.stopPropagation();
          this.open(new URL(href, location.origin).href, trigger);
        }
      }, true);

      this.frame.addEventListener('load', () => this.onFrameLoad());
      this.fullBtn.addEventListener('click', () => {
        if(window.dataLayer) window.dataLayer.push({ event: 'ds_preview_to_full', ds_preview_url: this.fullBtn.href });
      });

      const closeBtn = document.getElementById('DsPreviewClose');
      if(closeBtn) closeBtn.addEventListener('click', () => this.close());
      this.modal.addEventListener('click', (e) => { if(e.target === this.modal) this.close(); });
      document.addEventListener('keydown', (e) => {
        if(e.key === 'Escape' && this.modal.classList.contains('active')) this.close();
      });
      // Zurueck-Geste/-Taste schliesst die Vorschau statt den Artikel zu
      // verlassen. Nonce-Vertrag: iframe und Parent teilen EINE Session-
      // History; Scripts der inneren Seite koennen Eintraege pushen/poppen.
      // Geschlossen wird nur, wenn die History unseren AKTIVEN Vorschau-
      // Eintrag verlaesst, nicht wenn ein Pop auf ihm landet.
      window.addEventListener('popstate', (e) => {
        if(!this.modal.classList.contains('active')) return;
        if(e.state && e.state.dsPreview === this.historySeq) return;
        this.historyArmed = false;
        this.close();
      });

      // Kapitel-Anker (TOC) – unveraendert
      document.addEventListener('click', (e) => {
        if(e.target.closest('a[href^="#chapter-"]')) {
          e.preventDefault();
          const id = e.target.closest('a').getAttribute('href').substring(1);
          const el = document.getElementById(id);
          if(el) DsArticle.SmoothScroll.to(el);
        }
      });
    },

    // /cart.js liefert ohne Cache-Control-Header aus -> Safari cacht heuristisch
    // (GF-Befund: Badge erst nach ~45 s aktuell). Immer cache-fest lesen.
    fetchCart() {
      return fetch('/cart.js?ts=' + Date.now(), {
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      }).then(r => r.json());
    },

    open(url, trigger) {
      this.lastTrigger = trigger || null;
      this.loadCount = 0;
      this.atcBusy = false;
      DsArticle.ScrollLock.lock();
      this.modal.classList.add('active');
      this.modal.setAttribute('aria-hidden', 'false');
      this.loader.classList.add('active');
      this.previewBody.classList.remove('ready');
      this.fallback.hidden = true;
      this.frame.style.visibility = 'hidden';
      this.fullBtn.href = url;
      this.fallbackBtn.href = url;
      // Mobile verwaltet keine Tabs: Ausweg navigiert im selben Tab,
      // der Rueckweg in den Artikel laeuft ueber den Back-Button
      const sameTab = window.matchMedia('(max-width: 767px)').matches;
      this.fullBtn.target = sameTab ? '_self' : '_blank';
      this.fallbackBtn.target = sameTab ? '_self' : '_blank';
      // Analytics-Vertrag: Vorschau-Aufrufe sind in GA4/Clarity per
      // ds_preview=1 von echten PDP-Views trennbar (Steuerung/DiD!)
      let frameUrl = url;
      try {
        const u = new URL(url, location.origin);
        u.searchParams.set('ds_preview', '1');
        frameUrl = u.href;
      } catch(e) {}
      this.pendingUrl = frameUrl;
      if(window.dataLayer) window.dataLayer.push({ event: 'ds_preview_open', ds_preview_url: url });
      this.historySeq++;
      try { history.pushState({ dsPreview: this.historySeq }, ''); this.historyArmed = true; } catch(e) { this.historyArmed = false; }
      // location.replace statt src-Zuweisung: erzeugt keinen History-Eintrag
      try { this.frame.contentWindow.location.replace(frameUrl); }
      catch(e) { this.frame.src = frameUrl; }
      const closeBtn = document.getElementById('DsPreviewClose');
      if(closeBtn) closeBtn.focus({ preventScroll: true });
    },

    onFrameLoad() {
      if(!this.modal.classList.contains('active')) return;
      let doc = null, win = null;
      try {
        win = this.frame.contentWindow;
        doc = this.frame.contentDocument;
        if(!doc || !win || win.location.href === 'about:blank') {
          if(this.pendingUrl && !doc) this.showFallback();
          return;
        }
      } catch(e) {
        // Seite verweigert Framing (z.B. Checkout ohne Breakout) -> Ausweg anbieten
        this.showFallback();
        return;
      }
      this.loadCount++;
      this.pendingUrl = null;
      // Safety-Net fuer JS-getriebene Navigationen, die der Klick-Interceptor
      // nicht sehen kann: Warenkorb-Seite gehoert nicht ins Sheet -> eskalieren
      try {
        if(/^\/cart\/?$/.test(win.location.pathname)) {
          window.top.location.href = win.location.href;
          return;
        }
      } catch(e) {}
      this.loader.classList.remove('active');
      this.fallback.hidden = true;
      this.frame.style.visibility = 'visible';
      this.previewBody.classList.add('ready');
      // Footer-Button folgt der Navigation innerhalb der Vorschau
      // (ohne das interne ds_preview-Flag weiterzureichen)
      try {
        const u = new URL(win.location.href);
        u.searchParams.delete('ds_preview');
        this.fullBtn.href = u.href;
        this.fallbackBtn.href = u.href;
      } catch(e) {}
      this.wireFrame(doc, win);
    },

    // Kauf eskaliert IMMER aus dem Sheet heraus: Add-to-Cart bleibt in der
    // Vorschau (Drawer), aber Warenkorb-SEITE und Checkout navigieren im
    // obersten Fenster (Checkout blockt Framing ohnehin, und der mobile
    // Cart->Checkout-Drop vertraegt keine zusaetzliche Schicht).
    // composedPath statt e.target.closest: die Cart-Panels des Themes sind
    // Custom Elements mit Shadow DOM, closest() sieht den Link dort nicht.
    wireFrame(doc, win) {
      if(doc._dsWired) return;
      doc._dsWired = true;
      doc.addEventListener('click', (e) => {
        const path = e.composedPath ? e.composedPath() : [e.target];
        const a = path.find(n => n && n.tagName === 'A' && n.getAttribute && n.getAttribute('href'));
        if(!a) return;
        let u = null;
        try { u = new URL(a.getAttribute('href'), win.location.href); } catch(err) { return; }
        if(u.hostname !== location.hostname) return;
        if(/\/checkout/.test(u.pathname) || /^\/cart\/?$/.test(u.pathname)) {
          e.preventDefault(); e.stopPropagation();
          window.top.location.href = u.href;
        }
      }, true);
      doc.addEventListener('submit', (e) => {
        const path = e.composedPath ? e.composedPath() : [e.target];
        const form = path.find(n => n && n.tagName === 'FORM');
        if(!form) return;
        const submitter = e.submitter;
        const action = String(form.getAttribute('action') || '');
        if((submitter && submitter.name === 'checkout') || /\/checkout/.test(action)) {
          form.target = '_top';
        }
      }, true);
      // Watchdog: navigiert das iframe auf eine Seite, die Framing verweigert,
      // feuert Chromium KEIN load-Event (stille Einfrier-Falle). pagehide
      // startet den Timer, ein folgendes load loest ihn auf.
      win.addEventListener('pagehide', () => {
        if(!this.modal.classList.contains('active')) return;
        const seen = this.loadCount;
        this.loader.classList.add('active');
        setTimeout(() => {
          if(this.modal.classList.contains('active') && this.loadCount === seen) this.showFallback();
        }, 4000);
      });
      // Add-to-Cart in der Vorschau: Aufgabe erledigt -> Sheet schliesst,
      // Bestaetigung am Artikel (NN/g: Modal = abgegrenzte Aufgabe; Baymard:
      // ATC braucht eindeutiges Feedback). Die Shop-Panels liegen im
      // ausgeblendeten Header und sind hier keine Rueckmeldung mehr.
      // Erkennung am Netzwerk (fetch + XHR auf /cart/add), erst NACH der
      // Server-Antwort wird geschlossen, damit nichts abgebrochen wird.
      const uiRef = this;
      const origFetch = win.fetch;
      win.fetch = function() {
        const p = origFetch.apply(win, arguments);
        try {
          const u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
          if(/\/cart\/add/.test(u)) p.then(r => { if(r && r.ok) uiRef.onAtc(); }).catch(() => {});
        } catch(e) {}
        return p;
      };
      const XO = win.XMLHttpRequest.prototype.open;
      win.XMLHttpRequest.prototype.open = function() {
        this._dsCartAdd = /\/cart\/add/.test(String(arguments[1]));
        return XO.apply(this, arguments);
      };
      const XS = win.XMLHttpRequest.prototype.send;
      win.XMLHttpRequest.prototype.send = function() {
        if(this._dsCartAdd) this.addEventListener('load', () => {
          if(this.status >= 200 && this.status < 300) uiRef.onAtc();
        });
        return XS.apply(this, arguments);
      };
    },

    onAtc() {
      if(this.atcBusy || !this.modal.classList.contains('active')) return;
      this.atcBusy = true;
      // kurz warten, bis Theme-interne Folge-Requests durch sind
      setTimeout(() => {
        this.showToast();
        this.close();
        setTimeout(() => { this.atcBusy = false; }, 800);
      }, 250);
    },

    showToast() {
      if(!this.toastEl) {
        const t = document.createElement('div');
        t.className = 'ds-preview-toast';
        t.setAttribute('role', 'status');
        t.setAttribute('aria-live', 'polite');
        t.innerHTML = '<span>✓ Im Warenkorb</span><a href="/cart">Ansehen</a>';
        document.body.appendChild(t);
        this.toastEl = t;
      }
      clearTimeout(this.toastTimer);
      requestAnimationFrame(() => this.toastEl.classList.add('show'));
      this.toastTimer = setTimeout(() => this.toastEl.classList.remove('show'), 3500);
    },

    // Wisch-Geste am Grabber/Kopf (Apple-Sheet-Verhalten): Karte folgt dem
    // Finger, ab Schwelle oder Schwung schliesst sie, sonst federt sie zurueck.
    // Nur im Kopfbereich, damit sie nicht mit dem Scrollen im iframe kollidiert.
    initSwipe() {
      const zones = this.modal.querySelectorAll('.ds-preview-grabber, .ds-preview-header');
      let y0 = 0, t0 = 0, dy = 0, active = false;
      const reset = () => {
        this.wrapperEl.style.transition = '';
        this.wrapperEl.style.transform = '';
        active = false;
      };
      zones.forEach(z => {
        z.addEventListener('touchstart', (e) => {
          if(e.touches.length !== 1) return;
          y0 = e.touches[0].clientY; t0 = Date.now(); dy = 0; active = true;
          this.wrapperEl.style.transition = 'none';
        }, { passive: true });
        z.addEventListener('touchmove', (e) => {
          if(!active) return;
          dy = Math.max(0, e.touches[0].clientY - y0);
          if(dy > 0) {
            e.preventDefault();
            this.wrapperEl.style.transform = 'translateY(' + dy + 'px)';
          }
        }, { passive: false });
        z.addEventListener('touchend', () => {
          if(!active) return;
          const v = dy / Math.max(1, Date.now() - t0);
          this.wrapperEl.style.transition = '';
          if(dy > 120 || (dy > 30 && v > 0.5)) {
            this.wrapperEl.style.transform = 'translateY(110%)';
            setTimeout(() => this.close(), 180);
          } else {
            this.wrapperEl.style.transform = '';
          }
          active = false;
        }, { passive: true });
        z.addEventListener('touchcancel', reset, { passive: true });
      });
    },

    showFallback() {
      this.loader.classList.remove('active');
      this.frame.style.visibility = 'hidden';
      this.fallback.hidden = false;
      this.previewBody.classList.add('ready');
    },

    close() {
      if(!this.modal.classList.contains('active')) return;
      this.modal.classList.remove('active');
      this.modal.setAttribute('aria-hidden', 'true');
      // Inline-Styles der Wisch-Geste raeumen, damit die CSS-Animation
      // der naechsten Oeffnung wieder greift
      this.wrapperEl.style.transform = '';
      this.wrapperEl.style.transition = '';
      DsArticle.ScrollLock.unlock();
      // Eigenen History-Eintrag nur einsammeln, wenn in der Vorschau nicht
      // weiternavigiert wurde (sonst wuerde back() das iframe zurueckblaettern)
      if(this.historyArmed && this.loadCount <= 1 && history.state && history.state.dsPreview) {
        this.historyArmed = false;
        try { history.back(); } catch(e) {}
      }
      this.historyArmed = false;
      this.refreshCartCount();
      if(this.lastTrigger && this.lastTrigger.focus) this.lastTrigger.focus({ preventScroll: true });
      setTimeout(() => {
        try { this.frame.contentWindow.location.replace('about:blank'); }
        catch(e) { this.frame.src = 'about:blank'; }
        this.previewBody.classList.remove('ready');
        this.fallback.hidden = true;
      }, 400);
    },

    // In der Vorschau kann gekauft werden -> Warenkorb-Zaehler des Artikels
    // nachziehen. Artikel-Seiten rendern den Custom-Apple-Header
    // (.sn-cart-badge, server-seitig aus cart.item_count); die Standard-
    // Theme-Bubble (.cart-link__bubble) wird mit abgedeckt, falls ein
    // Template beide mischt.
    refreshCartCount() {
      this.fetchCart()
        .then(cart => {
          const count = cart.item_count || 0;
          // Bei leer geladenem Cart rendert der Header KEIN Badge-Element:
          // fuer den ersten Kauf aus der Vorschau selbst anlegen
          const cartBtn = document.getElementById('sn-cart-btn');
          if(count > 0 && cartBtn && !cartBtn.querySelector('.sn-cart-badge')) {
            const b = document.createElement('span');
            b.className = 'sn-cart-badge';
            cartBtn.appendChild(b);
          }
          document.querySelectorAll('.sn-cart-badge').forEach(b => {
            if(count > 0) { b.innerText = count; } else { b.remove(); }
          });
          document.querySelectorAll('.cart-link__bubble-num').forEach(el => { el.innerText = count; });
          document.querySelectorAll('.cart-link__bubble').forEach(b => {
            b.classList.toggle('cart-link__bubble--visible', count > 0);
          });
        })
        .catch(() => {});
    }
  },

  // 5. CONTENT
  Content: {
    init() {
      const container = document.getElementById('DsArticleContent');
      if(!container) return;

      const headings = container.querySelectorAll('h2');
      let tocHTML = '';
      headings.forEach((h, i) => {
         if(h.innerText.trim()) {
            h.id = 'chapter-' + i;
            tocHTML += `<a href="#chapter-${i}" class="ds-toc-link">${h.innerText}</a>`;
         }
      });

      if(tocHTML) {
         const desktopNav = document.getElementById('DsDesktopTocNav');
         if(desktopNav) desktopNav.innerHTML = tocHTML;
      } else {
         const sidebar = document.querySelector('.ds-sidebar-col');
         if(sidebar) sidebar.style.display = 'none';
      }

      container.querySelectorAll('table').forEach(t => {
         if(!t.parentNode.classList.contains('ds-table-wrapper')) {
            const c = document.createElement('div');
            c.className = 'ds-table-container';
            const w = document.createElement('div');
            w.className = 'ds-table-wrapper';
            t.parentNode.insertBefore(c, t);
            c.appendChild(w);
            w.appendChild(t);
            w.addEventListener('scroll', () => c.classList.add('scrolled'), {once: true, passive: true});
         }
      });

      // "Link kopieren" in der Share-Zeile (war bis v60.2 ein toter Knopf)
      const copyBtn = document.querySelector('.ds-copy-link');
      if(copyBtn) copyBtn.addEventListener('click', () => {
         const url = location.origin + location.pathname;
         const done = () => {
            copyBtn.classList.add('ds-copied');
            copyBtn.setAttribute('aria-label', 'Link kopiert');
            setTimeout(() => {
               copyBtn.classList.remove('ds-copied');
               copyBtn.setAttribute('aria-label', 'Link kopieren');
            }, 1800);
         };
         if(navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done).catch(() => {});
         } else {
            const ta = document.createElement('textarea');
            ta.value = url;
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); } catch(e) {}
            ta.remove();
         }
      });
    }
  },

  init() {
    if (this._initialized) return;
    this._initialized = true;

    this.Content.init();
    this.UI.init();
    // Audio: eigenstaendiges Modul assets/ds-audio.js (selbst-initialisierend)
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => DsArticle.init());
} else {
  DsArticle.init();
}


/* CTA-Klickflaeche, 28.07.2026.
   Anlass: 44 Dead Clicks in 30 Clarity-Sitzungen, die haeufigsten auf .ds-cta__desc
   (der Brustumfang-Satz). Nutzer klicken die Groessenangabe an und erwarten, dass
   etwas passiert. Der ganze CTA-Block wird deshalb klickbar.
   Bewusst per Listener statt per ::after-Overlay: ein Overlay wuerde die
   Textmarkierung blockieren, und Clarity zaehlt 16 Selected-Text-Ereignisse. */
(function () {
  function initDsCtaClickArea() {
    document.querySelectorAll('.ds-cta, .ds-cta-block').forEach(function (box) {
      if (box.dataset.dsClickable) return;
      var link = box.querySelector('a.ds-cta__link, a.ds-cta-block__link')
              || box.querySelector('a[href]');
      if (!link) return;
      box.dataset.dsClickable = '1';
      box.style.cursor = 'pointer';
      box.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        if (String(window.getSelection())) return;
        link.click();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDsCtaClickArea);
  } else {
    initDsCtaClickArea();
  }
})();

/* ---------------------------------------------------------------------------
   Zahl und Einheit zusammenhalten (22.08.2026)

   Auf dem Handy brach "14,50 €" mitten entzwei, die Zahl blieb am Zeilenende,
   das Waehrungszeichen rutschte allein in die naechste Zeile. Dasselbe bei
   "45 g", "10 %", "62,7 cm". DIN 5008 verlangt dort ohnehin ein geschuetztes
   Leerzeichen, im Bestand steht aber meist ein normales: 8.369 Fundstellen in
   363 Artikeln.

   Warum hier und nicht im Text: 363 Artikel-Mutationen waeren ein grosser
   Eingriff fuer ein Darstellungsproblem, und jeder neue Artikel braeuchte die
   Behandlung erneut. Diese elf Zeilen wirken auf den Bestand und auf alles,
   was noch kommt. Der Text selbst bleibt unangetastet, geaendert wird nur, was
   der Browser anzeigt.

   Bewusst eng gefasst: nur Ziffer, genau ein normales Leerzeichen, dann eine
   bekannte Einheit, gefolgt von einem Nicht-Buchstaben. "5 Gramm Fleisch"
   bleibt unberuehrt, "5 g Fleisch" wird zusammengehalten.
--------------------------------------------------------------------------- */
(function () {
  var EINHEIT = /(\d[\d.,]*) (€|EUR|%|kg|g|mg|cm|mm|km|ml|l)(?![\wäöüß])/g;
  function zusammenhalten(wurzel) {
    if (!wurzel) return;
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, null);
    var knoten = [];
    var n;
    while ((n = lauf.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf(' ') !== -1) knoten.push(n);
    }
    knoten.forEach(function (k) {
      var neu = k.nodeValue.replace(EINHEIT, '$1 $2');
      if (neu !== k.nodeValue) k.nodeValue = neu;
    });
  }
  function start() {
    ['.ds-rte', '.ds-faq-antwort', '.ds-faq-frage', '.ds-cta'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(zusammenhalten);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
